<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Tree
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <label for="treeselection" class="content__row-label">Tree Selection</label>
  <select *ngIf="isBrowser" [(ngModel)]="option" id="treeselection" placeholder="Tree Selection" name="treeselection" class="c-input-group__control" (change)="clearAllCheckbox()">
    <ng-container *ngFor="let item of optionList">
      <option *ngIf="item==='SingleNodeSelection'" [value]="item">Single Node Selection</option>
      <option *ngIf="item==='ParentChildSelection'" [value]="item">Parent Child Selection</option>
      <option *ngIf="item==='ParentToChild&SingleNodeSelection'" [value]="item">ParentToChild&SingleNodeSelection</option>
    </ng-container>
  </select>
  <ng-container *ngIf="isBrowser;else noJsContent">
    <maced-tree *ngIf="option==='ParentChildSelection'" treeId="treeId1" headerTitle="Title" name="tree1"
    [isSingleSelection]="false" [itemList]="treeItemList" [hasTreeLabel]="true" treeComponentLabel="Parent Child Selection" (treeEvent)="treeEvent($event)">
      <ng-container ngProjectAs="[treeActions]">
        <maced-button buttonId="clear1" icon="icon-x-close" label="Clear All" ariaLabel="Clear All" type="link"
          [queryParams]="{ clearCheckbox: 'clearCheckbox'}" [url]="currentUrl"
          > 
          >
        </maced-button>
      </ng-container>
    </maced-tree>
    <maced-tree *ngIf="option==='SingleNodeSelection'" #treecomponentSelection treeId="treeId3" headerTitle="Title" name="tree3"
      [isSingleSelection]="true" [itemList]="treeItemList" (treeEvent)="treeEvent($event)">
      <ng-container ngProjectAs="[treeActions]">
        <maced-button buttonId="clear3" icon="icon-x-close" label="Clear All" ariaLabel="Clear All" type="link"
          [queryParams]="{ clearCheckbox: 'clearCheckbox'}" [url]="currentUrl"
          >
        </maced-button>
        <span class="sr-only" id="clearAllButtonId" role="alert" aria-atomic="true"></span>
      </ng-container>
    </maced-tree>
    <maced-tree *ngIf="option==='ParentToChild&SingleNodeSelection'" treeId="treeId5" headerTitle="Title" name="tree3"
    [isParentToChildSelection]="true" [itemList]="treeItemList" (treeEvent)="treeEvent($event)">
    <ng-container ngProjectAs="[treeActions]">
      <maced-button buttonId="clear3" icon="icon-x-close" label="Clear All" ariaLabel="Clear All" type="link"
        [queryParams]="{ clearCheckbox: 'clearCheckbox'}" [url]="currentUrl">
      </maced-button>
    </ng-container>
  </maced-tree>
  </ng-container>
  <ng-template #noJsContent>
    <form action="/tree" method="get">
      <maced-tree treeId="treeId4" headerTitle="Title" name="tree4"
        [isSingleSelection]="true" [itemList]="treeItemList">
          <ng-container ngProjectAs="[treeActions]">
            <maced-button buttonId="clear2" icon="icon-x-close" label="Clear All" ariaLabel="Clear All" type="link"
              [queryParams]="{ clearCheckbox: 'clearCheckbox'}" [url]="currentUrl">
            </maced-button>
        </ng-container>
      </maced-tree>
      <br>
      <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button>
      <br />
      <br />
      Result-->{{ treeItemList|json }}
    </form>
  </ng-template>
  Result-->{{ itemList|json }}
</div>